import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { ClaimCardsListItem, ClaimRepayment, ClaimSelectPlace } from '@/modules/employer/components/Lockbox/lockbox.types';

import LockboxClaimCard from './LockboxClaimCard';

interface Props {
  fields: ClaimCardsListItem[];
  selectedClaims?: ClaimRepayment[];
  onSelectClaim?: () => void; 
  emptyState?: React.ReactNode;
  showWarnings?: boolean;
  isEditMode?: boolean;
  selectPlace?: ClaimSelectPlace;
}

const ClaimsList: React.FC<Props> = ({ fields, selectedClaims, onSelectClaim, emptyState, showWarnings, isEditMode, selectPlace }) => {
  const hasClaims = useMemo(() => fields?.length, [fields]);

  return (
    <>
      {hasClaims ? (
        fields?.map((claim, index) => {
          const selectedClaim = selectedClaims?.find((selectedClaim) => selectedClaim?.claimId === claim?.id);
          const isSelectedFromAnotherPlace = selectedClaim?.selectPlace && selectedClaim.selectPlace !== selectPlace;

          return (
            <Box key={claim?.id} {...index === 0 ? {} : { margin: { top: 'spacing8' } }}>
              <LockboxClaimCard
                testId="suggested-claim"
                itemKey={claim?.id}
                itemFields={claim?.fields}
                isSelected={!!selectedClaim}
                onSelect={onSelectClaim}
                isEditMode={isEditMode}
                showWarnings={showWarnings}
                warnings={claim?.warnings}
                isSelectedFromAnotherPlace={isSelectedFromAnotherPlace}
              />
            </Box>
          );
        })
      ) : emptyState}
    </>
  );
};

export default ClaimsList;
